module.exports = __webpack_public_path__ + "img/bookshelf23.5c95286c.jpg";